import { useDispatch } from 'react-redux';
import { updateContentDiff } from '../../../../features/componentFeatures/notificationPanelSlice';
import { resolveNotificationContent } from '../../../../utilities/notificationContentResolver';

const NotificationContent = ({ notificationContentData }) => {
  const dispatch = useDispatch();
  const ResolvedNotificationContent = resolveNotificationContent(
    notificationContentData.type,
  );

  if (!ResolvedNotificationContent) {
    return null;
  }

  const onChange = (newValue) =>
    dispatch(
      updateContentDiff({
        contentId: notificationContentData.contentId,
        textContent: newValue,
      }),
    );

  return (
    <div className="notification-content">
      <ResolvedNotificationContent
        textContent={notificationContentData.textContent}
        canEdit={notificationContentData.canEdit}
        onChange={onChange}
      />
    </div>
  );
};

export { NotificationContent };
